import { Edition } from './../../models/edition.model';
import { Moment } from 'moment';
import { Component } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { EditionsService } from '../../services/editions.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-publish',
  templateUrl: './main-publish.component.html',
  styleUrls: ['./main-publish.component.scss']
})
export class MainPublishComponent {
  selectedDate: Moment;
  edition: Edition;
  exist = true;
  constructor(
    private editionService: EditionsService,
    private router: Router
  ) { }

  onChange($event: MatDatepickerInputEvent<Moment>) {
    this.selectedDate = $event.value;
    this.editionService
      .getEditionByDate($event.value.toDate())
      .subscribe(v => {
        this.edition = v;
        this.exist = !(!this.edition);
        if (this.exist) {
          this.router.navigateByUrl(`/exportar/${this.edition.id}`);
        }
      });
  }
}
